import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { OfflineMessageStyle } from './style';

function OfflineMessage() {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <div style={OfflineMessageStyle(theme)}>
      <Typography variant="caption" color="text.black" noWrap>
        {intl.formatMessage({ id: 'offline', defaultMessage: 'Offline' })}
      </Typography>
    </div>
  );
}

export default OfflineMessage;
